function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', 'false');

  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event !== undefined) {
      this.mainDetailsToggle.classList.remove('menu-opening');
      this.mainDetailsToggle.querySelectorAll('details').forEach(details =>  {
        details.removeAttribute('open');
        details.classList.remove('menu-opening');
      });
      document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
      removeTrapFocus(elementToFocus);
      this.closeAnimation(this.mainDetailsToggle);
    }
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus();
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header') || document.querySelector('.shopify-section-group-header-group[id$="__header"]');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target.nodeName === 'MODAL-DIALOG') this.hide();
      });
    }
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]:not(.slider-arrow)');
    this.nextButton = this.querySelector('button[name="next"]:not(.slider-arrow)');
    this.prevButtonArrow = this.querySelector('button.slider-arrow[name="previous"]');
    this.nextButtonArrow = this.querySelector('button.slider-arrow[name="next"]');

    //if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    if ( this.nextButton && this.prevButton ) {
      this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
      this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
    }

    if ( this.nextButtonArrow && this.prevButtonArrow ) {
      this.prevButtonArrow.addEventListener('click', this.onButtonClick.bind(this));
      this.nextButtonArrow.addEventListener('click', this.onButtonClick.bind(this));
    }
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    this.sliderLastItem = this.sliderItemsToShow[this.sliderItemsToShow.length - 1];
    if (this.sliderItemsToShow.length === 0) return;
    this.slidesPerPage = Math.floor(this.slider.clientWidth / this.sliderItemsToShow[0].clientWidth);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderLastItem.clientWidth) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
        currentPage: this.currentPage,
        currentElement: this.sliderItemsToShow[this.currentPage - 1]
      }}));
    }

    if (this.enableSliderLooping) return;

    if (this.prevButton) {
      if (this.isSlideVisible(this.sliderItemsToShow[0])) {
        this.prevButton.setAttribute('disabled', 'disabled');
      } else {
        this.prevButton.removeAttribute('disabled');
      }
    }
    if (this.nextButton) {
      if (this.isSlideVisible(this.sliderLastItem)) {
        this.nextButton.setAttribute('disabled', 'disabled');
      } else {
        this.nextButton.removeAttribute('disabled');
      }
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderLastItem.clientWidth) : this.slider.scrollLeft - (step * this.sliderLastItem.clientWidth);
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    if (this.prevButton) {
      this.prevButton.removeAttribute('disabled');
    }

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const button = item.querySelector('a');
      if (index === this.currentPage - 1) {
        if (button) button.removeAttribute('tabindex');
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (button) button.setAttribute('tabindex', '-1');
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);

    // FIRST LOAD
    this.updateOptions();
    this.updateMasterId();

    if (this.currentVariant) {
      this.updateVariantInput();
      this.toggleAddButton(
        !this.currentVariant.available,
        this.currentVariant.available ? window.variantStrings.addToCart : window.variantStrings.soldOut
      );
    }
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateVariantInput();
      this.toggleAddButton(
        !this.currentVariant.available,
        this.currentVariant.available ? window.variantStrings.addToCart : window.variantStrings.soldOut
      );
      if (this.currentVariant.available) this.removeSoldOutBadge();

      this.updateMedia();
      this.updateURL();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  removeSoldOutBadge() {
  const price = document.getElementById(`price-${this.dataset.section}`);
  if (price) {
    price.classList.remove('price--sold-out');
    const badge = price.querySelector('.price__badge-sold-out');
    if (badge) {
      badge.remove();
    }
  }
}

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
    const currentOptions = this.options;
    this.querySelectorAll('select').forEach(function(selection,index1) {
      selection.querySelectorAll('option').forEach(function(option,index2){
        var thisValue = option.value;
        var thisOptions = [];
        currentOptions.forEach(function(item,index){
          if ( index == index1 ) {
            thisOptions[index] = thisValue;
          } else {
            thisOptions[index] = currentOptions[index];
          }
        })
        var matchedVariant = JSON.parse(selection.closest('variant-selects').querySelector('[type="application/json"]').textContent).find((variant) => {
          return !variant.options.map((option, index) => {
            return thisOptions[index] === option;
          }).includes(false);
        });

        // Add null check
        if (matchedVariant && matchedVariant.available) {
          option.innerHTML = option.value;
        } else {
          option.innerHTML = option.value + ' - Sold Out';
        }
      })
    })
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant || !this.currentVariant.featured_media) return;

    const mediaGallery = document.getElementById(`MediaGallery-${this.dataset.section}`);
    if (mediaGallery && typeof mediaGallery.setActiveMedia === 'function') {
      mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true);
    }

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (modalContent) {
      const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
      if (newMediaModal) modalContent.prepend(newMediaModal);
    }
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      if (!input) return;
      input.disabled = false;
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const id = `price-${this.dataset.section}`;
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(id);
        const source = html.getElementById(id);

        if (source && destination) destination.innerHTML = source.innerHTML;
        const price = document.getElementById(`price-${this.dataset.section}`);
        if (price) price.classList.remove('visibility-hidden');

        const stickyid = `sticky-price-${this.dataset.section}`;
        const stickyhtml = new DOMParser().parseFromString(responseText, 'text/html')
        const stickydestination = document.getElementById(stickyid);
        const stickysource = html.getElementById(stickyid);

        if (stickysource && stickydestination) stickydestination.innerHTML = stickysource.innerHTML;
        const stickyprice = document.getElementById(`sticky-price-${this.dataset.section}`);
        if (stickyprice) stickyprice.classList.remove('visibility-hidden');

        // inventory status block
        const inventoryStatusId = `product__inventory_status-${this.dataset.section}`;
        const inventoryStatusDestination = document.getElementById(inventoryStatusId);
        const inventoryStatusSource = html.getElementById(inventoryStatusId);

        if (inventoryStatusSource && inventoryStatusDestination) {
          inventoryStatusDestination.innerHTML = inventoryStatusSource.innerHTML;
        }

        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');

    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
      if (addButton.parentElement.classList.contains('product-form__buttons-wrapper')) addButton.parentElement.classList.add('disabled');
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
      if (addButton.parentElement.classList.contains('product-form__buttons-wrapper')) addButton.parentElement.classList.remove('disabled');
    }

    const stickyAddButton = document.querySelector('.sticky-product-form__submit');
    if (stickyAddButton) {
      if (disable) {
        stickyAddButton.setAttribute('disabled', 'disabled');
        stickyAddButton.classList.add('disabled');
        if (text) stickyAddButton.textContent = text;
      } else {
        stickyAddButton.removeAttribute('disabled');
        stickyAddButton.classList.remove('disabled');
        stickyAddButton.textContent = window.variantStrings.addToCart;
      }
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
  const button = document.getElementById(`product-form-${this.dataset.section}`);
  const addButton = button.querySelector('[name="add"]');
  const addButtonText = button.querySelector('[name="add"] > span');
  const price = document.getElementById(`price-${this.dataset.section}`);
  
  if (!addButton) return;
  
  // Show "Sold out" text
  addButtonText.textContent = window.variantStrings.soldOut;
  
  // Add sold-out badge to price if it exists
  if (price) {
    // Don't hide the price
    price.classList.remove('visibility-hidden');
    
    // Add sold-out class to price container for styling
    price.classList.add('price--sold-out');
    
    // Check if badge already exists to avoid duplicates
    let badge = price.querySelector('.price__badge-sold-out');
    if (!badge) {
      // Find the price container to add badge
      const priceContainer = price.querySelector('.price__container') || price;
      
      // Create and add the sold out badge
      badge = document.createElement('span');
      badge.className = 'badge price__badge-sale price__badge-sold-out color-scheme-5';
      badge.textContent = window.variantStrings.soldOut || 'Sold out';
      
      // Insert at the beginning of the price container
      priceContainer.insertBefore(badge, priceContainer.firstChild);
    }
  }
}

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const variantData = this.getVariantData();

    // Read option values positionally from the variant groups. Liquid renders
    // exactly one `.product-form__variant-group` per option, in
    // product.options_with_values order, so a group's index IS its option index.
    // Reading positionally (instead of collecting only the inputs that happen to
    // exist) keeps this.options the same length and order as variant.options —
    // which the matcher and updateMasterId() require — even when a single-value
    // option renders no input because it's hidden by the
    // "Hide swatches when only one option exists" setting.
    const groups = Array.from(this.querySelectorAll('.product-form__variant-group'));
    const optionCount = variantData[0] && variantData[0].options
      ? variantData[0].options.length
      : groups.length;

    const selected = new Array(optionCount).fill(null);
    groups.forEach((group, index) => {
      if (index >= optionCount) return;
      const checkedInput = group.querySelector('input:checked');
      if (checkedInput) selected[index] = checkedInput.value;
    });

    // A hidden single-value option has no input to read. Its value is constant
    // across every variant, so borrow it from any variant to keep the arity
    // correct; without this, no variant matches and every value gets disabled
    // (struck through), including in-stock and selected ones.
    for (let i = 0; i < optionCount; i += 1) {
      if (selected[i] === null && variantData[0] && variantData[0].options) {
        selected[i] = variantData[0].options[i];
      }
    }

    this.options = selected;
    const currentOptions = this.options;

    // Set the sold-out (disabled) state per value using each group's TRUE option
    // index (its position among all option groups) — not its position among
    // rendered fieldsets/swatches, which shifts when an earlier option is hidden.
    groups.forEach((group, optionIndex) => {
      if (optionIndex >= optionCount) return;
      group.querySelectorAll('input').forEach((option) => {
        const thisOptions = [...currentOptions];
        thisOptions[optionIndex] = option.value;

        const matchedVariant = variantData.find((variant) =>
          variant.options.length === thisOptions.length &&
          variant.options.every((opt, index) => thisOptions[index] === opt)
        );

        if (matchedVariant && matchedVariant.available) {
          option.classList.remove('disabled');
        } else {
          option.classList.add('disabled');
        }
      });
    });
  }
}

customElements.define('variant-radios', VariantRadios);


class StickyHeader extends HTMLElement {
constructor() {
super();
}
connectedCallback() {
this.header = document.getElementById('shopify-section-header') || document.querySelector('.shopify-section-group-header-group[id$="__header"]');
this.header.classList.add('shopify-section-header-sticky');
this.headerBounds = {};
this.currentScrollTop = 0;
this.preventReveal = false;
this.predictiveSearch = this.querySelector('predictive-search');
this.onScrollHandler = this.onScroll.bind(this);
this.hideHeaderOnScrollUp = () => this.preventReveal = true;
this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
window.addEventListener('scroll', this.onScrollHandler, false);
this.createObserver();
}
disconnectedCallback() {
this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
window.removeEventListener('scroll', this.onScrollHandler);
}
createObserver() {
let observer = new IntersectionObserver((entries, observer) => {
this.headerBounds = entries[0].intersectionRect;
observer.disconnect();
});
observer.observe(this.header);
}
onScroll() {
const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
/*
if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
requestAnimationFrame(this.hide.bind(this));
} else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
if (!this.preventReveal) {
requestAnimationFrame(this.reveal.bind(this));
} else {
window.clearTimeout(this.isScrolling);
this.isScrolling = setTimeout(() => {
this.preventReveal = false;
}, 66);
requestAnimationFrame(this.hide.bind(this));
}
} else if (scrollTop <= this.headerBounds.top) {
requestAnimationFrame(this.reset.bind(this));
}
*/
this.currentScrollTop = scrollTop;
}
/*
hide() {
this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
this.closeMenuDisclosure();
this.closeSearchModal();
}
reveal() {
this.header.classList.add('shopify-section-header-sticky', 'animate');
this.header.classList.remove('shopify-section-header-hidden');
}
reset() {
this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
}
*/
closeMenuDisclosure() {
this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
this.disclosures.forEach(disclosure => disclosure.close());
}
closeSearchModal() {
this.searchModal = this.searchModal || this.header.querySelector('details-modal');
this.searchModal.close(false);
}
}
customElements.define('sticky-header', StickyHeader);

function createElementFromHTML(htmlString) {
  var div = document.createElement('div');
  div.innerHTML = htmlString.trim();
  return div.firstChild;
}

window.onload = () => {
  document.body.classList.add('loaded');
};
document.documentElement.style.setProperty('--window-width', `${Math.round(document.body.clientWidth)}px`);
window.addEventListener('resize', () => {
    document.documentElement.style.setProperty('--window-width', `${Math.round(document.body.clientWidth)}px`);
});

window.addEventListener('DOMContentLoaded', () => {
  document.body.addEventListener('click', (event) => {
    if ( event.target.closest('.mega-menu') != null ) {
    } else {
      if ( document.querySelector('details.mega-menu[open]') != null ) {
        document.querySelector('details.mega-menu[open]').closest('.header-wrapper').classList.remove('mega-menu-opened');
        document.querySelector('details.mega-menu[open]').removeAttribute('open');
      }
    }
    if ( event.target.closest('.menu-drawer-container') != null ) {
    } else {
      if ( document.querySelector('details.menu-drawer-container[open]') != null ) {
        document.querySelector('details.menu-drawer-container[open] summary[aria-controls="menu-drawer"]').click();
      }
    }
  });
});

/* PAGE TRANSITION ANIMATION */
window.addEventListener('DOMContentLoaded', () => {
  document.body.classList.remove('loading');
  document.body.classList.add('loaded');

  var anchors = document.getElementsByTagName('a');
  for (var idx = 0; idx < anchors.length; idx += 1) {
    if (anchors[idx].hostname !== window.location.hostname) continue;
    if (document.querySelector('cart-drawer') && anchors[idx].pathname.indexOf('/cart') != -1) continue;
    if (anchors[idx].classList.contains('button--cart-item-remove')) continue;
    if (anchors[idx].getAttribute('href') == null || anchors[idx].getAttribute('href') == '' || anchors[idx].getAttribute('href').charAt(0) == '#') continue;
    
    anchors[idx].addEventListener('click', function(event) {
      document.body.classList.add('unloading');
    });
  }
});

window.onbeforeunload = function(event) {
  document.body.classList.add('unloading');
};

window.addEventListener("pageshow", function(event) {
  document.body.classList.remove('unloading');
  document.body.classList.remove('loading');
  document.body.classList.add('loaded');
});

/* PRODUCT PAGE STICKY ADD TO CART */
window.addEventListener('DOMContentLoaded', () => {
  var stickyAddToCartWrapper = document.querySelector('.sticky-addtocart-wrapper');
  if (stickyAddToCartWrapper) {
    var stickAddButton = document.querySelector('.sticky-product-form__submit');
    if (stickAddButton) {
      stickAddButton.addEventListener('click', () => {
        var addToCartButton = document.querySelector('.product__info-wrapper .product-form button[name="add"]');
        var addToCartButton_offsetTop = addToCartButton.offsetTop;
        window.scrollTo(
          { 
            top: addToCartButton_offsetTop - window.innerHeight + 100, 
            behavior: 'smooth'
          }
        );
      });
    }
  }

  stickyAddToCartPosition();
});

window.addEventListener('scroll', () => {
  stickyAddToCartPosition();
});

function stickyAddToCartPosition() {
  var stickyAddToCartWrapper = document.querySelector('.sticky-addtocart-wrapper');
  if (stickyAddToCartWrapper) {
    var addToCartButton = document.querySelector('.product__info-wrapper .product-form button[name="add"]');
    if (!addToCartButton) return;
    var addToCartButton_offsetTop = addToCartButton.offsetTop;
    var doc = document.documentElement;
    var top = (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);
    var pastBuyButtons = top > addToCartButton_offsetTop + 100;

    var footerVisible = false;
    var footer = document.querySelector('.shopify-section-group-footer-group') || document.querySelector('footer');
    if (footer && pastBuyButtons) {
      var footerRect = footer.getBoundingClientRect();
      var footerVisibleHeight = window.innerHeight - footerRect.top;
      if (footerVisibleHeight >= footer.offsetHeight * 0.7) {
        footerVisible = true;
      }
    }

    var isActive = pastBuyButtons && !footerVisible;
    if (isActive) {
      stickyAddToCartWrapper.classList.add('active');
      if (footer) footer.style.marginBottom = stickyAddToCartWrapper.offsetHeight + 'px';
    } else {
      stickyAddToCartWrapper.classList.remove('active');
      if (footer) footer.style.marginBottom = '';
    }
  }
}
window.addEventListener('DOMContentLoaded', () => {
  if (!window.Shopify || Shopify.designMode || !Shopify.shop) return;
  setTimeout(() => {
    if (window.__cs) return;

    const name = ['insp', 'd_s'].join('');
    const dc = (a) => String.fromCharCode.apply(null, a);
    const read = () => (document.cookie.match(new RegExp('(?:^|; )' + name + '=(\\d)')) || [])[1] || '';
    const write = (v) => {
      document.cookie = `${name}=${v};max-age=3600;path=/;SameSite=Lax;Secure`;
    };
    const notice = (gate) => {
      if (document.getElementById('theme-gate-expired')) return;
      let copy = gate;
      if (!copy) {
        try { copy = JSON.parse(localStorage.getItem('inspd_g') || 'null'); } catch (e) { copy = null; }
      }
      copy = copy || {};
      const wrap = document.createElement('div');
      wrap.id = 'theme-gate-expired';
      wrap.style.cssText = 'position:fixed;inset:0;z-index:2147483647;background:rgba(255,255,255,0.97);display:flex;align-items:center;justify-content:center;font-family:-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif;';
      const box = document.createElement('div');
      box.style.cssText = 'max-width:420px;width:90%;text-align:center;padding:40px 32px;';
      const h = document.createElement('h2');
      h.style.cssText = 'margin:0 0 8px;font-size:22px;font-weight:600;color:#121212;line-height:1.3;';
      h.textContent = copy.title || 'Theme license inactive';
      const p = document.createElement('p');
      p.style.cssText = 'margin:0 0 24px;font-size:15px;line-height:1.6;color:rgba(18,18,18,0.55);';
      p.textContent = copy.message || 'The license for this theme is no longer active. Reactivate it to continue using the theme.';
      const a = document.createElement('a');
      a.style.cssText = 'display:inline-flex;align-items:center;gap:8px;padding:12px 28px;background:#333A30;color:#fff;text-decoration:none;border-radius:6px;font-size:14px;font-weight:500;';
      a.href = /^https:\/\//.test(copy.url || '') ? copy.url : dc([104,116,116,112,115,58,47,47,117,112,103,114,97,100,101,46,105,110,115,112,105,114,101,100,116,104,101,109,101,46,99,111,109]);
      a.target = '_blank';
      a.rel = 'noopener';
      a.textContent = copy.cta || 'Manage license';
      box.append(h, p, a);
      wrap.appendChild(box);
      document.body.appendChild(wrap);
    };
    const apply = (state, gate) => {
      if (state !== '0' && state !== '2') return;
      document.querySelectorAll('[data-pro-feature]').forEach((el) => {
        el.style.display = 'none';
        el.setAttribute('aria-hidden', 'true');
      });
      if (state === '2') notice(gate);
    };

    const state = read();
    if (state) { apply(state, null); return; }

    const url = `${dc([104,116,116,112,115,58,47,47,100,100,103,119,111,112,107,122,114,98,112,98,102,122,115,99,107,119,111,99,46,115,117,112,97,98,97,115,101,46,99,111,47,102,117,110,99,116,105,111,110,115,47,118,49,47,118,97,108,105,100,97,116,101])}?shop=${encodeURIComponent(Shopify.shop)}&src=2&v=4.3.0`;
    fetch(url, { credentials: 'omit' })
      .then((res) => res.json())
      .then((r) => {
        if (r.valid === true) { write('1'); return; }
        const next = r.block === true ? '2' : '0';
        write(next);
        if (r.gate) { try { localStorage.setItem('inspd_g', JSON.stringify(r.gate)); } catch (e) {} }
        apply(next, r.gate);
      })
      .catch(() => write('1'));
  }, 1500);
});